import {
  INITIAL_STATE_SEARCH_PASSENGER,
  REQUEST_FETCH_SEARCH_PASSENGERS,
  FETCH_SEARCH_PASSENGERS_SUCCESS,
  FETCH_SEARCH_PASSENGERS_ERROR,
} from "../../../actions/reservations/passenger/fetchSearchPassengers";

const initialState = {
  passengers: [],
  processing: false,
  fetching: false,
  message: "",
  error: "",
};

const searchPassengerReducer = (state = initialState, action) => {
  switch (action.type) {
    case INITIAL_STATE_SEARCH_PASSENGER: {
      return {
        ...state,
        passengers: [],
        processing: false,
        fetching: false,
        message: "",
        error: "",
      };
    }
    case REQUEST_FETCH_SEARCH_PASSENGERS: {
      return {
        ...state,
        passengers: [],
        processing: false,
        fetching: true,
        message: "",
        error: "",
      };
    }
    case FETCH_SEARCH_PASSENGERS_SUCCESS: {
      return {
        ...state,
        passengers: action.passengers,
        processing: false,
        fetching: false,
        message: action.message,
        error: "",
      };
    }
    case FETCH_SEARCH_PASSENGERS_ERROR: {
      return {
        ...state,
        passengers: [],
        processing: false,
        fetching: false,
        message: "",
        error: action.error,
      };
    }
    default: {
      return state;
    }
  }
};
export default searchPassengerReducer;
